// Bengali — shared key set with the Flutter apps (lib/l10n).
// Auto-generated from the Dart source of truth; keep both in sync.
// Flat, dotted keys — i18n is configured with keySeparator:false.

const bn: Record<string, string> = {
  "common.save": "সংরক্ষণ করুন",
  "common.cancel": "বাতিল করুন",
  "common.delete": "মুছুন",
  "common.edit": "সম্পাদনা করুন",
  "common.add": "যোগ করুন",
  "common.close": "বন্ধ করুন",
  "common.back": "পিছনে",
  "common.done": "সম্পন্ন",
  "common.yes": "হ্যাঁ",
  "common.no": "না",
  "common.confirm": "নিশ্চিত করুন",
  "common.search": "অনুসন্ধান করুন",
  "common.retry": "আবার চেষ্টা করুন",
  "common.loading": "লোড হচ্ছে…",
  "common.offline": "অফলাইন",
  "nav.settings": "সেটিংস",
  "nav.orders": "অর্ডার",
  "nav.tables": "টেবিল",
  "nav.menu": "মেনু",
  "nav.reports": "রিপোর্ট",
  "roles.pos": "পয়েন্ট অফ সেল",
  "roles.kds": "কিচেন ডিসপ্লে",
  "roles.customer": "গ্রাহক ডিসপ্লে",
  "roles.captain": "ক্যাপ্টেন",
  "roles.kiosk": "সেলফ-অর্ডার কিয়স্ক",
  "order.dineIn": "ডাইন-ইন",
  "order.takeaway": "টেকঅ্যাওয়ে",
  "order.delivery": "ডেলিভারি",
  "order.quickBill": "কুইক বিল",
  "order.newOrder": "নতুন অর্ডার",
  "order.sendToKitchen": "কিচেনে পাঠান",
  "order.addItem": "আইটেম যোগ করুন",
  "order.cart": "কার্ট",
  "order.empty": "এখনও কোনো আইটেম নেই",
  "bill.settle": "বিল মেটান",
  "bill.subtotal": "উপ-মোট",
  "bill.discount": "ছাড়",
  "bill.total": "মোট",
  "bill.gst": "জিএসটি",
  "bill.customerName": "গ্রাহকের নাম",
  "bill.token": "টোকেন",
  "bill.billNo": "বিল নম্বর",
  "bill.splitBill": "বিল ভাগ করুন",
  "bill.splitBySeat": "আসন অনুযায়ী ভাগ করুন",
  "bill.pay": "পরিশোধ করুন",
  "bill.print": "প্রিন্ট করুন",
  "bill.paid": "পরিশোধিত",
  "bill.pending": "অপেক্ষমাণ",
  "table.free": "খালি",
  "table.occupied": "দখলকৃত",
  "table.transfer": "স্থানান্তর করুন",
  "table.merge": "একত্র করুন",
  "settings.language": "ভাষা",
  "settings.tax": "কর",
  "settings.printing": "প্রিন্টিং",
  "settings.account": "অ্যাকাউন্ট ও প্ল্যান",
  "settings.general": "সাধারণ",
  "settings.deviceMode": "ডিভাইস মোড",
  "settings.chooseLanguage": "ভাষা নির্বাচন করুন",
  "nav.order": "অর্ডার",
  "nav.online": "অনলাইন",
  "nav.activity": "কার্যকলাপ",
  "nav.history": "ইতিহাস",
  "nav.import": "ইম্পোর্ট",
  "nav.endShift": "শিফট শেষ করুন",
  "settings.title": "সেটিংস",
  "settings.subtitle": "আউটলেট, কর, প্রিন্টার, ভূমিকা ও বিল ফরম্যাট",
  "settings.sectionOutlet": "আউটলেট ও ব্র্যান্ডিং",
  "settings.sectionTax": "কর ও জিএসটি",
  "settings.sectionPrinters": "প্রিন্টার ও কেওটি",
  "settings.sectionRoles": "ভূমিকা ও অনুমতি",
  "settings.sectionBillFormat": "বিল ফরম্যাট",
  "settings.sectionChannels": "অনলাইন চ্যানেল",
  "settings.sectionAccount": "অ্যাকাউন্ট ও প্ল্যান",
  "settings.sectionAbout": "সম্পর্কে ও আপডেট",
  "order.viewCart": "কার্ট দেখুন",
  "order.categories": "বিভাগ",
  "order.tapToBuild": "অর্ডার তৈরি করতে খাবারে ট্যাপ করুন",
  "order.addNote": "নোট যোগ করুন",
  "order.searchDishes": "খাবার খুঁজুন",
  "bill.settleAndPrint": "মেটান ও প্রিন্ট করুন",
  "menu.title": "মেনু ও আইটেম",
  "menu.searchItems": "আইটেম খুঁজুন…",
  "menu.noItems": "এখানে কোনো আইটেম নেই",
  "menu.addItemBtn": "আইটেম যোগ করুন",
  "menu.tapAddItem": "তৈরি করতে “আইটেম যোগ করুন” ট্যাপ করুন",
  "menu.addCategory": "বিভাগ যোগ করুন",
  "menu.newCategory": "নতুন বিভাগ",
  "order.allFired": "সব পাঠানো হয়েছে",
  "bill.settling": "মেটানো হচ্ছে…"
};

export default bn;
